/**
 * Scroll-reveal motion.
 *
 * Adds `.is-visible` to any `.rh-reveal` element as it enters the viewport,
 * triggering the CSS transition defined in base/_typography.scss.
 * Respects prefers-reduced-motion and degrades gracefully without JS/IO support.
 */
((Drupal) => {
  Drupal.behaviors.rhinoReveal = {
    attach(context) {
      const els = once('rh-reveal', '.rh-reveal', context);
      if (!els.length) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !('IntersectionObserver' in window)) {
        els.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.12 },
      );

      els.forEach((el) => observer.observe(el));

      // Failsafe: never leave content hidden if the observer fails to fire
      // (e.g. layout quirks, programmatic scrolling). Reveal anything still
      // hidden after a few seconds so content is never stuck invisible.
      window.setTimeout(() => {
        els.forEach((el) => el.classList.add('is-visible'));
      }, 3000);
    },
  };
})(Drupal);
